import React from 'react';
import Hero from '../../components/hero/Hero';
import ProductsSection from '../../components/products/ProductsSection';
import ServicesSection from '../../components/services/ServicesSection';
import PricingSection from '../../components/pricing/PricingSection';
import ContactSection from '../../components/contact/ContactSection';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <ProductsSection />
      <PricingSection />
      <ServicesSection />
      <ContactSection />
    </>
  );
};

export default Home;

